import initGA from "./init-ga";
import { trackEvent, isServicePathname, inferServiceFromPathname, trackServicePageView } from "./ga4";

let previousPageLocation;

export function trackRoutePageView(location) {
  if (typeof window === "undefined" || typeof document === "undefined") return false;

  // Ignore hash-only navigation, but preserve query strings (including UTMs).
  const pageLocation = `${window.location.origin}${location.pathname}${location.search || ""}`;
  if (pageLocation === previousPageLocation) return false;

  initGA();
  const tracked = trackEvent("page_view", {
    page_path: location.pathname,
    page_location: pageLocation,
    page_referrer: previousPageLocation || document.referrer,
  });
  if (!tracked) return false;

  previousPageLocation = pageLocation;
  if (isServicePathname(location.pathname)) {
    trackServicePageView({
      service: inferServiceFromPathname(location.pathname),
      page_path: location.pathname,
    });
  }
  return true;
}
